import { MediaPartnerNotices, MediaPartnerNoticesResponse } from 'types/sanity/marketing-components';
import { useQueryWithContext, villusClient } from '@utils/villus';
import { MediaPartnerNoticesQuery } from './queries/media-partner-notices';

export async function getMediaPartnerNotices(context?: string): Promise<MediaPartnerNotices | null> {
	const { data } = await useQueryWithContext<MediaPartnerNoticesResponse>({
		client: villusClient,
		query: MediaPartnerNoticesQuery,
		baseTag: 'media_partner_notices',
		contextTag: context
	}).execute();

	return data?.allMediaPartnerNotices[0] ?? null;
}
